import React from 'react';

import type { UIPublicAttribute } from 'src/adapters/storeToUI/adaptPublicAttributesToUI';
import * as styles from './PublicAttributes.styles';

interface PublicAttributesProps {
  publicAttributes: UIPublicAttribute[];
}

export const PublicAttributes = ({ publicAttributes }: PublicAttributesProps) => {
  if (publicAttributes.length === 0) {
    return null;
  }

  return (
    <div css={styles.container}>
      {publicAttributes.map((attribute) => (
        <div css={styles.attributeItem} key={attribute.key}>
          <b>{attribute.title}</b>
          <span>{attribute.values.join(', ')}</span>
        </div>
      ))}
    </div>
  );
};
